import React from 'react';
import './PaginationBlock.css';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
const PaginationBlock = ({ setPage, documentsData }) => {
    return (
        <div className="row">
            <div className="col-12">
                <Stack spacing={2}>
                    <Pagination count={parseInt(Math.ceil((documentsData?.length) / 29)) || 1} onChange={(e, value) => setPage(value)} color="secondary" />
                </Stack>
            </div>
        </div>
    );
};

export default PaginationBlock;